// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"512":"45708339","874":"787b46a3"}[chunkId] + ".css";
};